import Vue from 'vue'
import { objectToForm } from '@/utils'

/**
 * @author Jorge Nunez L.
 *
 * @param payload sinister's cancellation to be sent
 *
 * Creates a new cancellation log
 */

const paramsTransformer = ({ sinisterNumber, cancellationReason, cancellationReasonText, supportFile }) => {
  return {
    sinister_number: sinisterNumber,
    cancellation_type: cancellationReason,
    cancellation_reason: cancellationReasonText,
    support_file: supportFile
  }
}
export default (payload) =>
  Vue.$http.post('sinister/view/sinister-cancellation-reason/', objectToForm(paramsTransformer(payload)))
    .then(response => response.data)
